/**
 * Removes null, undefined, and empty string values from an object
 * @param {Object} obj - The object to clean
 * @returns {Object} - A new object with null/undefined/empty string values removed
 */
export const removeNullValues = (obj) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    // Only include values that are not null, undefined, or empty strings
    if (value !== null && value !== undefined && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});
};
